import { Chip } from '@mui/material';
import React from 'react';

enum FlowStatus {
	disabled = 'disabled',
	active = 'active'
}

const FlowStatusChip: React.FC<{ status: `${FlowStatus}` }> = ({ status }) => {
	const disabled = status === FlowStatus.disabled;
	return (
		<Chip
			label={intl.tr(`flows.status.${status}`)}
			title={intl.tr(`flows.status.${status}`)}
			variant="outlined"
			size="small"
			data-testid="status-chip"
			color={!disabled ? 'info' : undefined}
			sx={{
				color: disabled ? 'text.disabled' : undefined
			}}
		/>
	);
};

export { FlowStatus };
export default FlowStatusChip;
